import { useStyle } from "@/classify"
import { useState } from "react"
import defaultClasses from "./cutOffText.module.css"

const CutOffText = (props) => {
  const { text, length, classes: propsClasses } = props
  const classes = useStyle(defaultClasses, propsClasses)

  const [expanded, setExpanded] = useState(false)

  if (text.length < length) {
    return <span className={classes.root}>{text}</span>
  }

  const content = expanded ? (
    <>
      {text}
      <span className={classes.switcherContainer}>
        <span className={classes.switcher} onClick={() => setExpanded(false)}>
          Read Less
        </span>
      </span>
    </>
  ) : (
    <>
      {text && text?.substring ? `${text?.substring(0, length - 1)}... ` : ""}
      <span className={classes.switcherContainer}>
        <span className={classes.switcher} onClick={() => setExpanded(true)}>
          Read More
        </span>
      </span>
    </>
  )

  return <span>{content}</span>
}

export default CutOffText
